import React from 'react'

interface LineProgressBarProps {
  percentage: number
  stroke: string
  strokeWidth: number
  isPercentage: boolean
  value: number
  textStyle?: string
}

const LineProgressBar: React.FC<LineProgressBarProps> = ({
  percentage,
  stroke,
  strokeWidth,
  isPercentage,
  value,
  textStyle,
}) => {
  return (
    <div className="w-full">
      <div className="flex gap-3 items-center">
        <div
          style={{
            height: `${strokeWidth * 4}px`,
          }}
          className={`w-full rounded-full bg-none`}
        >
          <div
            className={`rounded-full`}
            style={{
              width: `${percentage}%`,
              backgroundColor: stroke,
              height: `${strokeWidth * 4}px`,
            }}
          ></div>
        </div>
        <p
          className={`text-xs font-semibold leading-5 text-bluishGreen ${textStyle}`}
        >
          {isPercentage ? `${percentage}%` : value}
        </p>
      </div>
    </div>
  )
}

export default LineProgressBar
